export const DELETE_PERSON_MODAL_NAME = 'DELETE_PERSON_MODAL_NAME';
